module.exports = __webpack_public_path__ + "img/nobanner_new.9f8f5f47.png";